import Vue from 'vue';
import Antd from 'ant-design-vue';

import VueClipboard from 'vue-clipboard2';

// @ts-ignore
import infiniteScroll from 'vue-infinite-scroll';

import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import 'ant-design-vue/dist/antd.css';
import deep_copy from './global/func/deep_copy' // 深拷贝
import read_image from './utils/read_image' // 图像读取

Vue.use(infiniteScroll);

Vue.config.productionTip  = false;
Vue.prototype.$deep_copy  = deep_copy   // 数据深拷贝
Vue.prototype.$read_image = read_image  // 读取图片

Vue.use(Antd);
Vue.use(VueClipboard);

declare module 'vue/types/vue' {
  interface Vue {
    $deep_copy: any
    $read_image: any
  }
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
